import React from 'react';
import T from 'prop-types';
import { get } from 'lodash-es';
import {
  Section,
  Heading,
  Paragraph,
  IconStatusConfirmationOnlight,
  ButtonRow,
  Button,
  HorizontalRule,
} from '@piggybank/core';
import { Translation, TranslationScope } from 'srcAlias/client/locale';
import useTrackPageViewAnalytics from 'srcAlias/client/global/customHooks/useTrackPageViewAnalytics';
import { useSelector } from 'react-redux';
import { selectQueryParams } from 'srcAlias/client/state/selectors';
import { isMobileJourney } from 'srcAlias/client/utils/urlParameters';
import { clickContinue } from 'srcAlias/client/utils/clickContinue';
import config from 'configAlias';

const fullNameCss = {
  wordWrap: 'break-word',
};

export const Refer = ({ segmentName, pageName, customerData }) => {
  useTrackPageViewAnalytics('refer');
  const queryParams = useSelector(selectQueryParams);

  return (
    <TranslationScope path={`${segmentName}.${pageName}`}>
      <Section marginBottom={3}>
        <div style={{ color: '#00847f' }}>
          <IconStatusConfirmationOnlight width="2.5em" />
        </div>
        <Heading level={1} style={fullNameCss}>
          <Translation path="heading" />
          {get(customerData, 'individualDetail.name.fullName', '').slice(0, 70)}
          {get(config, 'appConfig.countryCode') !== 'SG' && (
            <Translation path="heading1" />
          )}
        </Heading>
      </Section>
      <Section>
        {get(config, 'appConfig.countryCode') !== 'SG' && (
          <Heading level={2} accentBar>
            <Translation path="brandBarHeading" />
          </Heading>
        )}
        <Paragraph>
          <Translation path="subHelpText" />
        </Paragraph>
        {get(config, 'appConfig.countryCode') !== 'SG' && (
          <Paragraph>
            <Translation path="subHelpText1" />
          </Paragraph>
        )}
      </Section>
      <HorizontalRule />
      <ButtonRow>
        {!isMobileJourney(queryParams) && (
          <Button
            onClick={() => clickContinue(pageName, __GOTOMYACCOUNT_URL__)}
            elementType="a"
            href={__GOTOMYACCOUNT_URL__}
            target="_self"
          >
            <Translation path="goToMyAccount" />
          </Button>
        )}
      </ButtonRow>
    </TranslationScope>
  );
};

Refer.propTypes = {
  segmentName: T.string,
  pageName: T.string,
  customerData: T.object,
};
